import styled, { css } from 'styled-components';

// Import icons
import { ReactComponent as IconFacebookSVG } from 'assets/icons/ic_auth_facebook.svg';
import { ReactComponent as IconGoogleSVG } from 'assets/icons/ic_auth_google.svg';
import { ReactComponent as IconPhoneSVG } from 'assets/icons/ic_phone.svg';
import { ReactComponent as IconAppleSVG } from 'assets/icons/ic_auth_apple.svg';

// Import components
import { Button } from 'components/elements';

// Import styles
import { flex, customMinResponsive, size } from 'components/styles';

const basicIconStyles = {
	width: '2rem',
	height: '2rem',
	marginRight: '1rem'
};

export const MethodsWrapper = styled.div`
	${flex({ fd: 'column' })}
	width: 100%;
	margin-top: 1.5rem;

	${customMinResponsive(
		size.medium,
		css`
			${flex({ jc: 'space-around' })};
		`
	)}
`;

export const StyledButton = styled(Button)`
	min-height: 4.2rem;
	min-width: 100%;
	background-color: ${({ backgroundColor }) => backgroundColor};
	color: ${({ textColor }) => textColor};
	margin: 1rem 0;
	padding: 0 ${({ isPureOtt }) => (isPureOtt ? 'inherit' : '0.6rem')};
	display: grid;
	align-items: center;
	grid-template-columns: ${({ columns = '10% 90%' }) => columns};
	line-height: 2rem;

	${customMinResponsive(
		size.medium,
		css`
			min-width: auto;
			flex: 1;
			margin: 0.5rem 0.25rem;
		`
	)}
`;

export const IconGoogle = styled(IconGoogleSVG)`
	${basicIconStyles}
`;

export const IconFacebook = styled(IconFacebookSVG)`
	${basicIconStyles}
`;

export const IconApple = styled(IconAppleSVG)`
	${basicIconStyles}

	path {
		fill: ${({ operator, theme }) => (operator ? theme.white : theme.black)};
	}
`;

export const IconPhone = styled(IconPhoneSVG)`
	${basicIconStyles}
	width: 1.5rem;
	height: 1.5rem;
`;

export const RecaptchaContainerWrapper = styled.div`
	position: relative;

	${({ isVisible }) =>
		!isVisible &&
		css`
			display: none;
		`}
`;

export const RecaptchaContainer = styled.div`
	height: 7.8rem;
	margin-bottom: 1.5rem;

	& > div {
		${flex()}
	}
`;

export const StyledFlag = styled.img`
	width: 4rem;
	height: 100%;
	margin-right: 1rem;
`;

export const BackButton = styled.button`
	color: ${({ theme }) => theme.authentication.linkColor};
	font-size: 1.4rem;
	letter-spacing: 0.45px;
	text-decoration: underline;
	background: transparent;
	border: none;
	cursor: pointer;
	margin-top: 1rem;

	&:hover {
		color: ${({ theme }) => theme.authentication.linkHoverColor};
		text-decoration: underline;
	}
`;

export const PhoneAuthenticationWrapper = styled.div`
	width: 50%;
	min-height: 26rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const SmsInfo = styled.p`
	margin-bottom: 1.8rem;
	line-height: 1.4;
	font-weight: ${({ theme }) => theme.font.medium};
	color: ${({ theme }) => theme.authentication.infoColor};
	${flex()}
	font-size: 1.4rem;
	height: 3rem;
`;

export const PhoneNumberWrapper = styled.div`
	${flex()}
	margin-bottom: 1.5rem;
`;
